import React from 'react';
import PropTypes from 'prop-types';

import { SOCIAL_DEMOGRAPHICS_REPORT_VIEW } from 'constants/capabilities';
import ProtectedComponent from 'hoc/ProtectedComponent';
import RenderingTile from 'components/molecules/RenderingTile';
import DemographicsBarChart from 'components/molecules/charts/DemographicsBarChart';
import ToggleDemographicsPivotTable from 'components/organisms/ToggleDemographicsPivotTable';
import { toolTipPointFormatterGenerator, labelFormatterGenerator } from 'helpers/charts';

const ProtectedDemographicsReports = ProtectedComponent({
    requiredCapabilities: [SOCIAL_DEMOGRAPHICS_REPORT_VIEW]
})(props => (
    <React.Fragment>
        { props.hasDemographicsData ? (
            <DemographicsBarChart
                exportName={props.exportName}
                title="FACEBOOK DEMOGRAPHIC ENGAGEMENT ANALYSIS"
                data={props.demographicsData}
                yAxisLabel="Engagement Rate"
                yAxisOptions={{
                    labels: {
                        formatter: labelFormatterGenerator('percentage')
                    }
                }}
                yOptions={{ formatByType: 'percentage' }}
                toolTipOptions={{
                    pointFormatter: toolTipPointFormatterGenerator
                }}
            />
        ) : (
            <RenderingTile height='465px' show={props.hasDemographicsData} />
        )}

        { props.hasDemographicsData ? (
            <ToggleDemographicsPivotTable
                exportName={`${props.exportName}-table`}
                hasDemographicsData={true}
                pivotBy={['age']}
                demographicsData={props.demographicsData}
                demographicsParams={props.demographicsParams}
                entityObjectiveLabelCode={props.entityObjectiveLabelCode}
                showSocialCpconv={props.showSocialCpconv}
            />
        ) : (
            <RenderingTile height='465px' show={props.hasDemographicsData} />
        )}
    </React.Fragment>
));

ProtectedDemographicsReports.propTypes = {
    hasDemographicsData: PropTypes.bool,
    demographicsData: PropTypes.arrayOf(PropTypes.shape({
        age: PropTypes.string,
        gender: PropTypes.string
    })),
    entityObjectiveLabelCode: PropTypes.string
};

export default ProtectedDemographicsReports;



// WEBPACK FOOTER //
// ./src/components/organisms/ProtectedDemographicsReports.js